import { Component, Input, EventEmitter, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router, RouterLinkActive, RouterModule } from '@angular/router';
import { AuthService, UserType } from '../../modules/auth/services/auth.service';
import { LogoutService } from '../../shared/services/logout.service';
import { Subscription } from 'rxjs';
import { UserInitialsUtil } from '../../shared/utils/user-initials.util';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from '../../services/reports/report.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [NgIf, RouterLinkActive, RouterModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input() isOpen: boolean = false;

  currentUser: UserType;
  userInitials: string = 'JC'; // valor por defecto
  showRiskAdjustmentScorecard: boolean = false;
  private unsubscribe: Subscription[] = [];

  // Traducciones para el menú
  menuLabels = {
    dashboard: 'Dashboard',
    qualityScorecard: 'Quality Score Cards',
    riskAdjustmentScorecard: 'Risk Adjustment Score Cards',
    mySchedule: 'My Schedule',
    myPatients: 'My Patients',
    reports: 'Reports',
    pocketGuides: 'Resources',
    settings: 'Settings',
    notifications: 'Notifications',
    /*userAccounts: 'User Accounts',
    invites: 'Invites',
    aboutUs: 'About Us',*/
    logout: 'Log Out'
  };

  constructor(
    private router: Router,
    private authService: AuthService,
    private logoutService: LogoutService,
    private translateService: TranslateService,
    private reportService: ReportService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    const userSubscription = this.authService.currentUser$.subscribe((user) => {
      this.currentUser = user;
      this.updateUserInitials();
    });
    this.unsubscribe.push(userSubscription);

    // Cargar traducciones iniciales
    this.loadTranslations();

    // Suscribirse a cambios de idioma
    const langSubscription = this.translateService.onLangChange.subscribe(() => {
      this.loadTranslations();
    });
    this.unsubscribe.push(langSubscription);

    // El menu de Risk Adjustment Scorecard se controla con el setting "SHOW RA SCORECARD"
    const raScorecardSubscription = this.reportService
      .getShowRiskAdjustmentScorecardEnabled()
      .subscribe((enabled: boolean) => {
        this.showRiskAdjustmentScorecard = enabled;
        this.cdr.detectChanges();
      });
    this.unsubscribe.push(raScorecardSubscription);
  }

  ngOnDestroy(): void {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  private updateUserInitials(): void {
    this.userInitials = UserInitialsUtil.generateFromUser(this.currentUser, 'JC');
  }

  private loadTranslations(): void {
    this.menuLabels = {
      dashboard: this.translateService.instant('SIDEBAR_MENU.DASHBOARD'),
      qualityScorecard: this.translateService.instant('SIDEBAR_MENU.QUALITY_SCORECARD'),
      riskAdjustmentScorecard: this.translateService.instant('SIDEBAR_MENU.RISK_ADJUSTMENT_SCORECARD'),
      mySchedule: this.translateService.instant('SIDEBAR_MENU.MY_SCHEDULE'),
      myPatients: this.translateService.instant('SIDEBAR_MENU.MY_PATIENTS'),
      reports: this.translateService.instant('SIDEBAR_MENU.REPORTS'),
      pocketGuides: this.translateService.instant('SIDEBAR_MENU.POCKET_GUIDES'),
      settings: this.translateService.instant('SIDEBAR_MENU.SETTINGS'),
      notifications: this.translateService.instant('SIDEBAR_MENU.NOTIFICATIONS'),
      /*userAccounts: this.translateService.instant('SIDEBAR_MENU.USER_ACCOUNTS'),
      invites: this.translateService.instant('SIDEBAR_MENU.INVITES'),
      aboutUs: this.translateService.instant('SIDEBAR_MENU.ABOUT_US'),*/
      logout: this.translateService.instant('SIDEBAR_MENU.LOGOUT')
    };
  }

  logout(): void {
    const logoutSubscription = this.logoutService.logout({
      showConfirmation: true,
      redirectTo: '/auth/login',
      preserveLanguage: true
    }).subscribe({
      next: (success) => {
      },
      error: (error) => {
        console.error('Logout error in sidebar:', error);
      }
    });

    this.unsubscribe.push(logoutSubscription);
  }
}
